const jobsTeaserListItems = document.querySelectorAll('.jobs-teaser__job');
const jobsTeaserExpandListLink = document.querySelector('.jobs-teaser__expand-list-link');

if (jobsTeaserExpandListLink) {
    jobsTeaserExpandListLink.addEventListener('click', link => {
        link.preventDefault();
        jobsTeaserExpandListLink.hidden = true;

        jobsTeaserListItems.forEach(job => {
            job.hidden = false;
        });
    });
}
